import { spaceToken } from "@poscon/shared-types/eram";
export function dispatchCommandRecall(recall) {
    document.dispatchEvent(new CustomEvent("recallcommand", {
        detail: recall,
    }));
}
export function dispatchInsertCommandEvent(command, withSpace = true) {
    const commandToInsert = withSpace ? [...command, spaceToken] : command;
    document.dispatchEvent(new CustomEvent("insertcommand", {
        detail: {
            command: commandToInsert,
        },
    }));
}
export function dispatchUiSyncInputEvent(detail) {
    document.dispatchEvent(new CustomEvent("ui:sync:input", {
        detail,
    }));
}
export function dispatchUiSyncScrollEvent(detail) {
    document.dispatchEvent(new CustomEvent("ui:sync:scroll", {
        detail,
    }));
}
export function dispatchUiSyncMcaInputEvent(detail) {
    document.dispatchEvent(new CustomEvent("ui:sync:mcaInput", {
        detail,
    }));
}
//# sourceMappingURL=customEvents.js.map